<div class="ml-5">
    <p id="gestion-des-utilisateurs" class="titre1 m-4">{{ 'USERS_MANAGEMENT.USERS_MANAGEMENT' |
        translate }}
        <mat-icon
            class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-2 float-right">people_alt</mat-icon>
    </p>
    <div class="hidden md:block overflow-x-auto">
        <div *ngIf="isLoading" class="flex justify-center items-center h-64">
            <mat-spinner color="accent"></mat-spinner>
        </div>
        <ng-container *ngIf="!isLoading">
            <div class="flex justify-between items-center mb-3">
                <div class="inline-flex rounded-md shadow-sm" role="group">
                    <button type="button"
                        [ngClass]="{'bg-red-600 text-white': filter === 'all', 'bg-gray-200 text-gray-700': filter !== 'all'}"
                        (click)="setFilter('all')"
                        class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                        {{ 'USERS_MANAGEMENT.SHOW_ALL' | translate }}
                    </button>
                    <button type="button"
                        [ngClass]="{'bg-red-600 text-white': filter === 'active', 'bg-gray-200 text-gray-700': filter !== 'active'}"
                        (click)="setFilter('active')"
                        class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                        {{ 'USERS_MANAGEMENT.ACTIVE' | translate }}
                    </button>
                    <button type="button"
                        [ngClass]="{'bg-red-600 text-white': filter === 'inactive', 'bg-gray-200 text-gray-700': filter !== 'inactive'}"
                        (click)="setFilter('inactive')"
                        class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                        {{ 'USERS_MANAGEMENT.INACTIVE' | translate }}
                    </button>
                    <button type="button"
                        [ngClass]="{'bg-red-600 text-white': filter === 'invitation', 'bg-gray-200 text-gray-700': filter !== 'invitation'}"
                        (click)="setFilter('invitation')"
                        class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                        {{ 'USERS_MANAGEMENT.PENDING_INVITATION' | translate }}
                    </button>
                </div>
                <div class="items-end justify-end mb-3 gap-4">
                    <ng-container *ngIf="!utilisateurService.contexteUtilisateur.aTenantSSO; else ssoButtons">
                        <button *ngIf="!estRootLectureSeule"
                            (click)="!estLimiteUtilisateursAtteinte && openInviteDialogInvitUtilisateur()"
                            [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                            [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                            class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
                            {{ 'USERS_MANAGEMENT.INVITE_USERS' | translate }}
                        </button>
                        <button *ngIf="!estRootLectureSeule"
                            (click)="!estLimiteUtilisateursAtteinte && openInviteDialogInvitAdminPilote()"
                            [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                            [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                            class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
                            {{ (estUtilisateurPilote ? 'USERS_MANAGEMENT.INVITE_ADMINS_PILOTS' :
                            'USERS_MANAGEMENT.INVITE_ADMIN_ONLY') | translate }}
                        </button>
                    </ng-container>
                    <ng-template #ssoButtons>
                        <button *ngIf="!estRootLectureSeule"
                            (click)="!estLimiteUtilisateursAtteinte && openCreerUtilisateurTenantSSODialog()"
                            [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                            [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                            class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
                            {{ 'USERS_MANAGEMENT.CREATE_USER_TENANT_SSO' | translate }}
                        </button>
                        <button *ngIf="!estRootLectureSeule"
                            (click)="!estLimiteUtilisateursAtteinte && openCreerAdminPiloteTenantSSODialog()"
                            [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                            [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                            class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
                            {{ (estUtilisateurPilote ? 'USERS_MANAGEMENT.CREATE_ADMIN_PILOT_TENANT_SSO' :
                            'USERS_MANAGEMENT.CREATE_ADMIN_TENANT_SSO') | translate }}
                        </button>
                    </ng-template>
                    <button *ngIf="!estRootLectureSeule && utilisateurService.contexteUtilisateur.aUtilisateursFictifs"
                        (click)="!estLimiteUtilisateursAtteinte && openInviteDialogCreerUtilisateursFictifs()"
                        [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                        [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                        class="btn-primary-novo disabled:text-gray-200 disabled:border-gray-300 disabled:cursor-not-allowed disabled:bg-red-200">
                        {{ 'USERS_MANAGEMENT.CREATE_FICTITIOUS_USERS' | translate }}
                    </button>
                    <button [matMenuTriggerFor]="exportMenu" [disabled]="isLoading || !utilisateursFiltreEncours.length"
                        class="btn-primary-novo btn-export ml-2">
                        {{ 'USERS_MANAGEMENT.EXPORT' | translate }}
                        <mat-icon>expand_more</mat-icon>
                    </button>
                    <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
                        <button mat-menu-item (click)="exporterVersExcel()">
                            <mat-icon>table_view</mat-icon>
                            <span>{{ 'USERS_MANAGEMENT.EXPORT_EXCEL' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="exporterVersPdf()">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <span>{{ 'USERS_MANAGEMENT.EXPORT_PDF' | translate }}</span>
                        </button>
                    </mat-menu>
                </div>
            </div>


            <div class="flex items-end justify-end mb-4 gap-3">
                <mat-select [(ngModel)]="selectedEntreprises" (selectionChange)="applyFilters()" multiple
                    placeholder="{{ 'USERS_MANAGEMENT.ALL_ENTITIES' | translate }}"
                    class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1 dark:text-white"
                    panelWidth="320" panelHeight="100">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="entiteFilterCtrl"
                            [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
                            [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let entite of filteredEntites | async" [value]="entite">
                        {{entite.nom | EmptyString }} <span *ngIf="!entite.estActif">({{ 'ENTITE_INACTIF' | translate }})</span>
                    </mat-option>
                </mat-select>

                <mat-select [(ngModel)]="selectedNames" (selectionChange)="applyFilters()" multiple
                    placeholder="{{ 'USERS_MANAGEMENT.ALL_NAMES' | translate }}"
                    class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1 dark:text-white"
                    panelWidth="320" panelHeight="100">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="nameFilterCtrl"
                            [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
                            [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let name of filteredNames | async" [value]="name">
                        {{name}}
                    </mat-option>
                </mat-select>


                <mat-select placeholder="{{ 'USERS_MANAGEMENT.ALL_EMAILS' | translate }}" multiple
                    class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1 dark:text-white"
                    panelWidth="320" panelHeight="100" [(ngModel)]="selectedEmails" (selectionChange)="applyFilters()">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="emailFilterCtrl"
                            [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
                            [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                        {{email}}
                    </mat-option>
                </mat-select>

                <mat-select placeholder="{{ 'USERS_MANAGEMENT.FILTRE_ETIQUETTE' | translate }}" multiple
                    class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
                    panelHeight="100" [(ngModel)]="selectionEtiquette" (selectionChange)="applyFilters()">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="etiquetteFilterCtrl" class="hidden sm:block"
                            [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
                            [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let etq of filteredEtiquettes | async" [value]="etq.etiquetteId">
                        <span [style.background-color]="etq.couleur" [style.color]="obtenirCouleur(etq.couleur)"
                            class="px-2 py-1 rounded-full text-sm mr-1">
                            {{ getEtiquetteName(etq.etiquetteId) }}
                        </span>
                    </mat-option>
                </mat-select>


                <mat-select placeholder="{{ 'USERS_MANAGEMENT.ALL_ROLES' | translate }}" multiple
                    class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1 dark:text-white"
                    panelWidth="320" panelHeight="100" [(ngModel)]="selectedRoles" (selectionChange)="applyFilters()">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="roleFilterCtrl"
                            [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate"
                            [noEntriesFoundLabel]="'USERS_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let role of filteredRoles | async" [value]="role">
                        {{role}}
                    </mat-option>
                </mat-select>

                <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
                    placeholder="{{ 'CONTENUS_MANAGEMENT.SEARCH' | translate }}..."
                    class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
                <button mat-icon-button (click)="resetFilters()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
                    <mat-icon>restore</mat-icon>
                </button>
            </div>
            <div class="flex justify-between items-center mb-2">
                <div class="flex-grow flex justify-center items-center space-x-4">
                    <button *ngIf="anySelected && hasActiveSelectedUsers() && !estRootLectureSeule"
                        (click)="desactiverUtilisateurs()"
                        class="px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 font-semibold rounded-lg border border-red-300 shadow-sm transition duration-300 ease-in-out flex items-center">
                        <mat-icon class="mr-2">close</mat-icon>
                        <span>{{ 'USERS_MANAGEMENT.DEACTIVATE' | translate }}</span>
                    </button>
                    <button *ngIf="anySelected && hasSelectedInvitationEnAttente() && !estRootLectureSeule"
                        (click)="confirmerReenvoyerInvitations()"
                        class="px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 font-semibold rounded-lg border border-red-300 shadow-sm transition duration-300 ease-in-out flex items-center">
                        <mat-icon class="mr-2">send</mat-icon>
                        <span>{{ 'USERS_MANAGEMENT.RESEND_INVITATION' | translate }}</span>
                    </button>
                    <div class="relative">
                        <button *ngIf="anySelected && !estRootLectureSeule" (click)="toggleEtiquettesMenu()"
                            class="px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 font-semibold rounded-lg border border-red-300 shadow-sm transition duration-300 ease-in-out flex items-center">
                            <mat-icon class="mr-2">label</mat-icon>
                            <span>{{ 'USERS_MANAGEMENT.MANAGE_LABELS' | translate }}</span>
                        </button>

                        <div *ngIf="showEtiquettesMenu" class="etiquettes-menu-contextuel">
                            <button (click)="ajouterEtiquettes()"
                                class="w-full px-4 py-2 text-left bg-gray-500 hover:bg-gray-800 flex items-center">
                                <mat-icon class="mr-2">add</mat-icon>
                                {{ 'USERS_MANAGEMENT.ADD_LABELS' | translate }}
                            </button>
                            <button (click)="supprimerEtiquettes()"
                                class="w-full px-4 py-2 text-leftbg-gray-500  hover:bg-gray-800 flex items-center">
                                <mat-icon class="mr-2">remove</mat-icon>
                                {{ 'USERS_MANAGEMENT.REMOVE_LABELS' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full overflow-x-auto">
                <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
                    (matSortChange)="sortDataChange($event)">
                    <ng-container matColumnDef="choix">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"></th>
                        <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                            <input title="checkbox" type="checkbox"
                                class="form-checkbox h-4 w-4 transition duration-150 ease-in-out"
                                [checked]="element.isSelected" (change)="toggleUserSelection(element)">
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2"> {{
                            'USERS_MANAGEMENT.NAME' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b">
                            <ng-container *ngIf="element.estInvitationEnAttente; else nomUtilisateur">
                            </ng-container>
                            <ng-template #nomUtilisateur>
                                {{ element.nom }}
                            </ng-template>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                            'USERS_MANAGEMENT.EMAIL' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b">
                            {{element.email}}
                            <mat-icon *ngIf="element.estFictif"
                                class="material-symbols-outlined ml-2 align-middle text-gray-500"
                                style="font-size: 18px; width: 18px; height: 18px;">frame_person</mat-icon>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="etat">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">
                            {{ 'USERS_MANAGEMENT.STATUS_COL_TITLE' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                            {{ getEtatUtilisateur(element) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="role-entreprise">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                            'USERS_MANAGEMENT.ROLE_COMPANY' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                            <ng-container *ngIf="element.estActif">
                                <div *ngFor="let roleEntite of element.tousLesRolesEntites" class="mb-1">
                                    <span class="text-sm font-medium dark:text-white">
                                        {{ utilisateurService.obtenirDenominationRole(roleEntite.roleId) |
                                        translate }} -
                                    </span>
                                    <span class="text-sm text-gray-500">{{ roleEntite.nomEntite }}</span>
                                </div>
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="etiquettes">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                            'USERS_MANAGEMENT.TAGS' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                            <div class="flex flex-wrap">
                                <span *ngFor="let etiquetteId of element.toutesLesEtiquettes"
                                    [style.background-color]="getEtiquetteColor(etiquetteId)"
                                    [style.color]="obtenirCouleur(getEtiquetteColor(etiquetteId))"
                                    class="px-2 py-1 rounded-full text-sm mr-1 mb-1">
                                    {{ getEtiquetteName(etiquetteId) }}
                                </span>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="dateDerniereConnexion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                            'USERS_MANAGEMENT.LAST_CONNECTION_DATE' | translate }}</th>
                        <td mat-cell *matCellDef="let element"
                            class="hidden md:table-cell text-center px-4 py-2 border-b"> {{
                            element.dateDerniereConnexion | customDateHeure }} </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>{{ 'USERS_MANAGEMENT.ACTIONS' | translate }}</th>
                        <td mat-cell *matCellDef="let element" class="w-1/20 px-2 py-1 text-center">
                            <div class="menu-container">
                                <button (click)="toggleMenu(element)"
                                    class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                                    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                                </button>
                                <div *ngIf="element.isMenuOpen"
                                    class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                                    <div class="py-1" *ngIf="element.estInvitationEnAttente && !estRootLectureSeule" role="menu"
                                        aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="obtenirCodeInvitation(element.utilisateurId)"
                                            [class.opacity-50]="!element.estModifiable"
                                            [class.cursor-not-allowed]="!element.estModifiable"
                                            [matTooltip]="!element.estModifiable ? ('USERS_MANAGEMENT.CODE_INVITATION_DISABLED_TOOLTIP' | translate) : ''">
                                            {{ 'USERS_MANAGEMENT.CODE_INVITATION' | translate }}
                                        </a>
                                    </div>
                                    <div class="py-1" *ngIf="element.estModifiable && !estRootLectureSeule" role="menu"
                                        aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="editUser(element.utilisateurId)"
                                            [class.opacity-50]="!element.estModifiable"
                                            [class.cursor-not-allowed]="!element.estModifiable"
                                            [matTooltip]="!element.estModifiable ? ('USERS_MANAGEMENT.EDIT_DISABLED_TOOLTIP' | translate) : ''">
                                            {{ 'USERS_MANAGEMENT.EDIT' | translate }}
                                        </a>
                                    </div>
                                    <div class="py-1"
                                        *ngIf="element.estActif && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== element.utilisateurId && !estRootLectureSeule"
                                        role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem"
                                            (click)="element.estModifiable && onClickDesactiver(element)"
                                            [class.opacity-50]="!element.estModifiable"
                                            [class.cursor-not-allowed]="!element.estModifiable"
                                            [matTooltip]="!element.estModifiable ? ('USERS_MANAGEMENT.DEACTIVATE_DISABLED_TOOLTIP' | translate) : ''">
                                            {{ 'USERS_MANAGEMENT.DEACTIVATE' | translate }}
                                        </a>
                                    </div>
                                    <div class="py-1"
                                        *ngIf="!element.estActif && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== element.utilisateurId && !estRootLectureSeule"
                                        role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="onClickActiverUtilisateur(element)">{{
                                            (element.estFictif || element.ssoId) ? ('USERS_MANAGEMENT.ACTIVATE' |
                                            translate) : ('USERS_MANAGEMENT.INVITE_AND_ACTIVATE' | translate)
                                            }}</a>
                                    </div>
                                    <div class="py-1"
                                        *ngIf="element.estInvitationEnAttente && !element.estFictif && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== element.utilisateurId && !estRootLectureSeule"
                                        role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="onClickReenvoyerInvitation(element)">{{
                                            'USERS_MANAGEMENT.RESEND_INVITATION' |
                                            translate }}</a>
                                    </div>
                                    <div class="py-1" *ngIf="element.estFictif && !estRootLectureSeule" role="menu"
                                        aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="onClickforcerMotDePasse(element)">{{
                                            'USERS_MANAGEMENT.FORCE_PASSWORD' | translate
                                            }}</a>
                                    </div>
                                    <div class="py-1"
                                        *ngIf="!element.estFictif && utilisateurService.contexteUtilisateur.aUtilisateursFictifs && !estRootLectureSeule && element.ssoId"
                                        role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="onClickConvertirEnFictif(element)">{{
                                            'USERS_MANAGEMENT.CONVERT_TO_FICTITIOUS' | translate
                                            }}</a>
                                    </div>
                                    <div class="py-1" role="menu" aria-orientation="vertical"
                                        aria-labelledby="options-menu">
                                        <a href="javascript:void(0)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem" (click)="ajouterDocument(element.utilisateurId)">{{
                                            'USERS_MANAGEMENT.AJOUTER_DOCUMENT' | translate
                                            }}</a>
                                    </div>
                                    <div class="py-1" role="menu" aria-orientation="vertical"
                                        aria-labelledby="options-menu">
                                        <a href="javascript:void(0)" (click)="rapportFormations(element.utilisateurId)"
                                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                            role="menuitem">{{ 'USERS_MANAGEMENT.TRAINING_HISTORY' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                        [ngClass]="{'ligne-gray': !element.estActif}"></tr>
                </table>

                <div *ngIf="dataSource.filteredData.length === 0" class="text-center mt-2 text-gray-500">
                    {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
                </div>

                <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
                </mat-paginator>
            </div>
        </ng-container>
    </div>
    <div class="md:hidden space-y-4">
        <div class="mb-4">
            <h2 id="gestion-des-utilisateurs-1" class="text-xl font-bold">Gestion des utilisateurs</h2>
        </div>

        <button (click)="toggleFiltres()"
            class="w-full bg-white hover:bg-gray-100 text-black py-2 px-4 rounded border border-gray-300">
            {{ (afficherFiltreMobile ? 'USERS_MANAGEMENT.HIDE_ADVANCED_FILTERS' :
            'USERS_MANAGEMENT.SHOW_ADVANCED_FILTERS') |
            translate }}
        </button>

        <div *ngIf="afficherFiltreMobile" class="space-y-4">
            <div class="inline-flex rounded-md shadow-sm" role="group">
                <button type="button"
                    [ngClass]="{'bg-red-600 text-white': filter === 'all', 'bg-gray-200 text-gray-700': filter !== 'all'}"
                    class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    (click)="setFilter('all')">
                    {{ 'USERS_MANAGEMENT.SHOW_ALL' | translate }}
                </button>
                <button type="button"
                    [ngClass]="{'bg-red-600 text-white': filter === 'active', 'bg-gray-200 text-gray-700': filter !== 'active'}"
                    class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    (click)="setFilter('active')">
                    {{ 'USERS_MANAGEMENT.ACTIVE' | translate }}
                </button>
                <button type="button"
                    [ngClass]="{'bg-red-600 text-white': filter === 'inactive', 'bg-gray-200 text-gray-700': filter !== 'inactive'}"
                    class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    (click)="setFilter('inactive')">
                    {{ 'USERS_MANAGEMENT.INACTIVE' | translate }}
                </button>
                <button type="button"
                    [ngClass]="{'bg-red-600 text-white': filter === 'invitation', 'bg-gray-200 text-gray-700': filter !== 'invitation'}"
                    class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    (click)="setFilter('invitation')">
                    {{ 'USERS_MANAGEMENT.PENDING_INVITATION' | translate }}
                </button>
            </div>
            <div class="flex flex-col space-y-2">
                <mat-form-field>
                    <mat-label>{{ 'USERS_MANAGEMENT.ALL_ENTITIES' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedEntreprises" (selectionChange)="applyFilters()" multiple>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="entiteFilterCtrl"
                                [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let entite of filteredEntites | async" [value]="entite">
                            {{entite}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'USERS_MANAGEMENT.ALL_NAMES' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedNames" (selectionChange)="applyFilters()" multiple>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="nameFilterCtrl"
                                [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let name of filteredNames | async" [value]="name">
                            {{name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'USERS_MANAGEMENT.ALL_EMAILS' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedEmails" (selectionChange)="applyFilters()" multiple>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="emailFilterCtrl"
                                [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let email of filteredEmails | async" [value]="email">
                            {{email}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>{{ 'USERS_MANAGEMENT.ALL_ROLES' | translate }}</mat-label>
                    <mat-select [(ngModel)]="selectedRoles" (selectionChange)="applyFilters()" multiple>
                        <mat-option>
                            <ngx-mat-select-search [formControl]="roleFilterCtrl"
                                [placeholderLabel]="'USERS_MANAGEMENT.SEARCH' | translate">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let role of filteredRoles | async" [value]="role">
                            {{role}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

            </div>
            <div class="relative">
                <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
                    placeholder="{{ 'USERS_MANAGEMENT.SEARCH' | translate }}"
                    class="w-full px-3 py-2 border rounded-lg text-gray-700 focus:outline-none focus:border-blue-500" />
            </div>
        </div>
        <div class="flex flex-col space-y-2 mb-2">
            <ng-container *ngIf="!utilisateurService.contexteUtilisateur.aTenantSSO; else ssoButtonsMobile">
                <button *ngIf="!estRootLectureSeule"
                    (click)="!estLimiteUtilisateursAtteinte && openInviteDialogInvitUtilisateur()"
                    [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                    [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                    class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:text-gray-200 disabled:bg-red-200 disabled:cursor-not-allowed">
                    {{ 'USERS_MANAGEMENT.INVITE_USERS' | translate }}
                </button>
                <button *ngIf="!estRootLectureSeule"
                    (click)="!estLimiteUtilisateursAtteinte && openInviteDialogInvitAdminPilote()"
                    [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                    [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                    class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:text-gray-200 disabled:bg-red-200 disabled:cursor-not-allowed">
                    {{ (estUtilisateurPilote ? 'USERS_MANAGEMENT.INVITE_ADMINS_PILOTS' :
                    'USERS_MANAGEMENT.INVITE_ADMIN_ONLY') | translate }}
                </button>
            </ng-container>
            <ng-template #ssoButtonsMobile>
                <button *ngIf="!estRootLectureSeule"
                    (click)="!estLimiteUtilisateursAtteinte && openCreerUtilisateurTenantSSODialog()"
                    [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                    [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                    class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:text-gray-200 disabled:bg-red-200 disabled:cursor-not-allowed">
                    {{ 'USERS_MANAGEMENT.CREATE_USER_TENANT_SSO' | translate }}
                </button>
                <button *ngIf="!estRootLectureSeule"
                    (click)="!estLimiteUtilisateursAtteinte && openCreerAdminPiloteTenantSSODialog()"
                    [disabled]="estLimiteUtilisateursAtteinte" [matTooltip]="messageTooltipLimite"
                    [matTooltipDisabled]="!estLimiteUtilisateursAtteinte"
                    class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded disabled:text-gray-200 disabled:bg-red-200 disabled:cursor-not-allowed">
                    {{ (estUtilisateurPilote ? 'USERS_MANAGEMENT.CREATE_ADMIN_PILOT_TENANT_SSO' :
                    'USERS_MANAGEMENT.CREATE_ADMIN_TENANT_SSO') | translate }}
                </button>
            </ng-template>
        </div>

        <div *ngFor="let utilisateur of utilisateursAffiches" class="bg-white p-4 rounded-lg shadow">
            <p class="mb-2 text-gray-900"><span class="font-semibold">{{ 'USERS_MANAGEMENT.NAME' | translate }}:</span>
                <ng-container *ngIf="utilisateur.estInvitationEnAttente; else nomUtilisateur">
                </ng-container>
                <ng-template #nomUtilisateur>
                    {{ utilisateur.nom }}
                </ng-template>
            </p>
            <p class="mb-2 text-gray-900"><span class="font-semibold">{{ 'USERS_MANAGEMENT.STATUS' | translate
                    }}:</span>
                {{ getEtatUtilisateur(utilisateur) }}
            </p>
            <p class="mb-2 text-gray-900"><span class="font-semibold">{{ 'USERS_MANAGEMENT.EMAIL' | translate }}:</span>
                {{
                utilisateur.email }}
                <mat-icon *ngIf="utilisateur.estFictif"
                    class="material-symbols-outlined ml-2 align-middle text-gray-500"
                    style="font-size: 18px; width: 18px; height: 18px;">frame_person</mat-icon>
            </p>
            <div class="mt-2 text-gray-900">
                <p class="font-semibold">{{ 'USERS_MANAGEMENT.ROLE_COMPANY' | translate }}:</p>
                <ng-container *ngIf="!utilisateur.estActif">
                    <span class="text-gray-700">{{ utilisateurService.obtenirNomEntite(utilisateur.entiteId) }}</span>
                </ng-container>
                <ng-container *ngIf="utilisateur.estActif">
                    <div *ngFor="let roleEntite of utilisateur.tousLesRolesEntites" class="mb-1">
                        <span class="text-sm font-medium text-gray-900">
                            {{ utilisateurService.obtenirDenominationRole(roleEntite.roleId) | translate }} -
                        </span>
                        <span class="text-sm text-gray-500">{{ roleEntite.nomEntite }}</span>
                    </div>
                </ng-container>
            </div>
            <div class="mt-2 text-gray-900">
                <p class="font-semibold">{{ 'USERS_MANAGEMENT.TAGS' | translate }}:</p>
                <div class="flex flex-wrap mt-1">
                    <span *ngFor="let etiquetteId of utilisateur.toutesLesEtiquettes"
                        [style.background-color]="getEtiquetteColor(etiquetteId)"
                        [style.color]="obtenirCouleur(getEtiquetteColor(etiquetteId))"
                        class="px-2 py-1 rounded-full text-sm mr-1 mb-1">
                        {{ getEtiquetteName(etiquetteId) }}
                    </span>

                </div>
            </div>
            <p class="mb-2 text-gray-900"><span class="font-semibold">{{ 'USERS_MANAGEMENT.LAST_CONNECTION_DATE' |
                    translate
                    }}:</span> {{
                utilisateur.dateDerniereConnexion |
                customDateHeure }}</p>
            <p class="mb-2 text-gray-900"><span class="font-semibold">{{ 'USERS_MANAGEMENT.ACTIVE' | translate
                    }}:</span> {{
                utilisateur.estActif ?
                ('USERS_MANAGEMENT.YES' |
                translate) : ('USERS_MANAGEMENT.NO' | translate) }}</p>
            <div class="mt-4 overflow-visible flex justify-end">
                <!-- Bouton Modifier commenté pour l'affichage mobile -->
                <!-- <button *ngIf="!estRootLectureSeule" (click)="editUser(utilisateur.utilisateurId)"
                    [disabled]="!utilisateur.estModifiable"
                    class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
                    [ngClass]="{'opacity-50 cursor-not-allowed': !utilisateur.estModifiable}"
                    [matTooltip]="!utilisateur.estModifiable ? ('USERS_MANAGEMENT.EDIT_DISABLED_TOOLTIP' | translate) : ''">
                    <mat-icon>edit</mat-icon>
                </button> -->

                <!-- Bouton menu 3 points commenté pour l'affichage mobile -->
                <!-- <div class="menu-container inline-block relative">
                    <button (click)="toggleMenu(utilisateur)"
                        class="bg-grey-500 hover:bg-grey-700 text-gray-700 font-bold py-2 px-4 rounded border border-gray-300">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                    </button>
                    <div *ngIf="utilisateur.isMenuOpen"
                        class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                        <div class="py-1"
                            *ngIf="utilisateur.estActif && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== utilisateur.utilisateurId && !estRootLectureSeule"
                            role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="utilisateur.estModifiable && onClickDesactiver(utilisateur)"
                                [class.opacity-50]="!utilisateur.estModifiable"
                                [class.cursor-not-allowed]="!utilisateur.estModifiable"
                                [matTooltip]="!utilisateur.estModifiable ? ('USERS_MANAGEMENT.DEACTIVATE_DISABLED_TOOLTIP' | translate) : ''">
                                {{ 'USERS_MANAGEMENT.DEACTIVATE' | translate }}
                            </a>
                        </div>
                        <div class="py-1"
                            *ngIf="!utilisateur.estActif && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== utilisateur.utilisateurId"
                            role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="onClickActiverUtilisateur(utilisateur)">{{
                                'USERS_MANAGEMENT.ACTIVATE' | translate
                                }}</a>
                        </div>
                        <div class="py-1"
                            *ngIf="utilisateur.estInvitationEnAttente && utilisateurService.entiteUtilisateurSelectionnee.utilisateurId !== utilisateur.utilisateurId"
                            role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="onClickReenvoyerInvitation(utilisateur)">{{
                                'USERS_MANAGEMENT.RESEND_INVITATION' |
                                translate
                                }}</a>
                        </div>
                        <div class="py-1" *ngIf="utilisateur.estFictif && !estRootLectureSeule" role="menu"
                            aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="onClickforcerMotDePasse(utilisateur)">{{
                                'USERS_MANAGEMENT.FORCE_PASSWORD' |
                                translate
                                }}</a>
                        </div>
                        <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem" (click)="ajouterDocument(utilisateur.utilisateurId)">{{
                                'USERS_MANAGEMENT.AJOUTER_DOCUMENT' | translate
                                }}</a>
                        </div>
                        <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                            <a href="javascript:void(0)" (click)="rapportFormations(utilisateur.utilisateurId)"
                                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                                role="menuitem">{{ 'USERS_MANAGEMENT.TRAINING_HISTORY' | translate }}</a>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</div>
